import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import renderHTML from 'react-render-html';

export default class MapListTitle extends Component {
    getClasses() {
        return this.props.isSingle ? 'title-block' : 'card-title';
    }

    render() {
        console.log(this.props);
        if (this.props.content) {
	        return ( renderHTML( this.props.content ) )
        } else {
	        return null;
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/main/article/maplisttitle.js